import React, { Component } from "react";
import StepProgress from "../../Helpers/StepProgress";
import PropTypes from "prop-types";
import "./Progress.css";

export default class Progress extends Component {

    render() {
        const { horizontal } = this.props;

        return (
            <div className={horizontal ? "SidePanel-root-horizontal" : "SidePanel-root"}>
                {this.props.title && (
                    <div className={horizontal ? "SidePanel-header-horizontal" : "SidePanel-header SidePanel-Progress-header"}>
                        {this.props.title}
                    </div>
                )}
                <div className={horizontal ? "SidePanel-Progress-steps-horizontal" : "SidePanel-Progress-steps"}>
                    <StepProgress
                        steps={this.props.steps}
                        current={this.props.current}
                        max={this.props.max}
                        resource={this.props.resource}
                        handleClick={(i) => {
                            if (this.props.handleClick)
                                this.props.handleClick(i);
                        }}
                        disableProgress={this.props.disableProgress}
                        horizontal={horizontal}
                    />
                </div>
                {((this.props.footer == true) ? true : false) &&
                    this.props.footer
                }
            </div>
        );
    }

}

Progress.propTypes = {
    title: PropTypes.node,
    steps: PropTypes.arrayOf(PropTypes.node).isRequired,
    current: PropTypes.number,
    handleClick: PropTypes.func,
    max: PropTypes.number,
    footer: PropTypes.node,
    resource: PropTypes.string.isRequired
}